import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetIdentification } from '../../../../state';

const SerialNumberEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetIdentification({ serialNumber: event.target.value }));
  };

  return (
    <TextField
      label="Serial Number"
      size="small"
      fullWidth
      value={currentAsset?.serialNumber || ''}
      onChange={handleChange}
    />
  );
};

export default SerialNumberEdit;
